module.exports = __webpack_public_path__ + "img/kj.75395bec.svg";